import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "./Global";
import './i18n';
import FPERouter from './FPERouter';
import reportWebVitals from './reportWebVitals';
import { RecoilRoot } from "recoil";
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "./ErrorPage";
import { AlertDisplay } from "./components/AlertDisplay";
import { AxiosErrorHandle } from './components/AxiosErrorHandle';

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <AxiosErrorHandle>
        <ErrorBoundary FallbackComponent={ErrorPage}>
          <FPERouter />
          <AlertDisplay/>
        </ErrorBoundary>
      </AxiosErrorHandle>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
